var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCgLogoTextPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.055,
    height: 27,
    viewBox: "0 0 153.055 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49269",
    "data-name": "Path 49269",
    d: "M1.392,11.49h0l.016.021.019.026h0a7.206,7.206,0,0,0,3.779,2.626c.012,0,.308.084.317.087.477.122.959-.148,1.566-.5A20.524,20.524,0,0,0,9.418,12.1c.459-.411-.065-.477-.41-.461s-2.46.066-4-.016a19.19,19.19,0,0,1-3.345-.494A.69.69,0,0,0,1.5,11.1c-.257,0-.2.234-.109.385m12.7-3.7a16.614,16.614,0,0,1-2.722,3.587,16.215,16.215,0,0,1-2.607,2.139c-1.263.887-1.087.928-.649.882l.023-.006a7.214,7.214,0,0,0,6.094-5.6.084.084,0,0,0,.008-.021c.1-.431.227-1.271.081-1.271-.046,0-.119.083-.229.287M4.318,5.912c-.39.4-1.255,1.308-1.771,1.958A19.157,19.157,0,0,0,1.424,9.432c-.2.313-.47.71.005.875a17.276,17.276,0,0,0,3.48.557c1.853.1,4.3.016,4.706-.025s.541-.329.32-.559S8.18,8.552,7.491,7.87,5.72,6.142,5.523,5.945a1,1,0,0,0-.66-.269.743.743,0,0,0-.545.236M1.54,2.766l-.063.078A7.207,7.207,0,0,0,0,7.185v.081A7.264,7.264,0,0,0,.242,9.087l.02.071c.116.344.383.094.53-.137a17.43,17.43,0,0,1,1.082-1.53c.59-.749,1.574-1.76,1.968-2.172a.675.675,0,0,0,.049-.971C3.744,4.2,2.44,2.9,2.252,2.745a.6.6,0,0,0-.37-.128.427.427,0,0,0-.342.15M7.161,0A7.151,7.151,0,0,0,2.9,1.434c-.01.011-.1.085-.1.085-.213.214-.238.469.049.757.254.255,1.476,1.448,1.607,1.563a.756.756,0,0,0,.984-.016c.361-.329,1.574-1.349,2.132-1.761A13.825,13.825,0,0,1,9.188,1.009C9.67.763,9.9.573,9.659.44A.292.292,0,0,0,9.615.417,7.163,7.163,0,0,0,7.242,0Z",
    fill: "#4698cb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14165",
    "data-name": "Rectangle 14165",
    width: 14.549,
    height: 14.476,
    fill: "#4698cb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25670",
    "data-name": "Group 25670",
    transform: "translate(-58.945 -22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24408",
    "data-name": "Group 24408",
    transform: "translate(-8.172 -2.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24555",
    "data-name": "Group 24555",
    transform: "translate(0 10.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49383",
    "data-name": "Path 49383",
    d: "M324.352,307.079l1.793.233a4.654,4.654,0,0,1-1.5,2.9,4.383,4.383,0,0,1-2.973,1.048,4.618,4.618,0,0,1-3.55-1.443,5.856,5.856,0,0,1-1.342-4.138,7.485,7.485,0,0,1,.578-3.049,4.026,4.026,0,0,1,1.757-1.96,5.212,5.212,0,0,1,2.567-.653,4.463,4.463,0,0,1,2.867.886,4.064,4.064,0,0,1,1.428,2.517l-1.772.273a2.943,2.943,0,0,0-.9-1.631,2.319,2.319,0,0,0-1.555-.547,2.829,2.829,0,0,0-2.238.988,4.687,4.687,0,0,0-.861,3.124,4.846,4.846,0,0,0,.831,3.15,2.7,2.7,0,0,0,2.168.982,2.555,2.555,0,0,0,1.793-.658A3.27,3.27,0,0,0,324.352,307.079Z",
    transform: "translate(-249.659 -276.057)",
    fill: "#d42733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49384",
    "data-name": "Path 49384",
    d: "M353.065,309.692a6.768,6.768,0,0,1-1.95,1.216,5.63,5.63,0,0,1-2.01.354,3.911,3.911,0,0,1-2.725-.866,2.858,2.858,0,0,1-.952-2.213,2.942,2.942,0,0,1,.359-1.443,2.984,2.984,0,0,1,.942-1.049,4.442,4.442,0,0,1,1.312-.6,13.061,13.061,0,0,1,1.621-.274,16.664,16.664,0,0,0,3.251-.628c.007-.25.01-.409.01-.476a2.012,2.012,0,0,0-.516-1.57,3.051,3.051,0,0,0-2.076-.618,3.219,3.219,0,0,0-1.9.451,2.751,2.751,0,0,0-.907,1.6l-1.783-.243a4.417,4.417,0,0,1,.8-1.849,3.509,3.509,0,0,1,1.61-1.084,7.189,7.189,0,0,1,2.441-.38,6.464,6.464,0,0,1,2.238.324,2.953,2.953,0,0,1,1.266.815,2.876,2.876,0,0,1,.567,1.241,10.257,10.257,0,0,1,.091,1.681v2.431a25.784,25.784,0,0,0,.117,3.216,4.047,4.047,0,0,0,.461,1.292h-1.9A3.868,3.868,0,0,1,353.065,309.692Zm-.152-4.071a13.387,13.387,0,0,1-2.978.689,6.887,6.887,0,0,0-1.59.364,1.587,1.587,0,0,0-.719.592,1.612,1.612,0,0,0,.3,2.082,2.376,2.376,0,0,0,1.615.486,3.761,3.761,0,0,0,1.874-.461,2.84,2.84,0,0,0,1.206-1.261,4.4,4.4,0,0,0,.294-1.823Z",
    transform: "translate(-267.999 -276.057)",
    fill: "#d42733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49385",
    "data-name": "Path 49385",
    d: "M381.4,303.137l.263,1.611a6.8,6.8,0,0,1-1.378.162,3.116,3.116,0,0,1-1.54-.314,1.756,1.756,0,0,1-.77-.826,6.521,6.521,0,0,1-.223-2.152v-6.189h-1.337v-1.418h1.337v-2.663l1.813-1.094v3.758H381.4v1.418h-1.833v6.29a3.185,3.185,0,0,0,.1,1,.756.756,0,0,0,.314.354,1.208,1.208,0,0,0,.623.132A5.953,5.953,0,0,0,381.4,303.137Z",
    transform: "translate(-287.833 -269.804)",
    fill: "#d42733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49386",
    "data-name": "Path 49386",
    d: "M401.135,309.692a6.771,6.771,0,0,1-1.95,1.216,5.63,5.63,0,0,1-2.01.354,3.911,3.911,0,0,1-2.725-.866,2.858,2.858,0,0,1-.952-2.213,2.942,2.942,0,0,1,.359-1.443,2.981,2.981,0,0,1,.942-1.049,4.442,4.442,0,0,1,1.311-.6,13.081,13.081,0,0,1,1.621-.274,16.664,16.664,0,0,0,3.251-.628c.006-.25.01-.409.01-.476a2.012,2.012,0,0,0-.517-1.57,3.051,3.051,0,0,0-2.077-.618,3.219,3.219,0,0,0-1.9.451,2.751,2.751,0,0,0-.906,1.6l-1.783-.243a4.415,4.415,0,0,1,.8-1.849,3.508,3.508,0,0,1,1.61-1.084,7.189,7.189,0,0,1,2.441-.38,6.465,6.465,0,0,1,2.239.324,2.953,2.953,0,0,1,1.266.815,2.874,2.874,0,0,1,.567,1.241,10.266,10.266,0,0,1,.091,1.681v2.431a25.744,25.744,0,0,0,.117,3.216,4.046,4.046,0,0,0,.461,1.292h-1.9A3.873,3.873,0,0,1,401.135,309.692Zm-.152-4.071a13.39,13.39,0,0,1-2.978.689,6.883,6.883,0,0,0-1.59.364,1.585,1.585,0,0,0-.72.592,1.612,1.612,0,0,0,.3,2.082,2.376,2.376,0,0,0,1.616.486,3.76,3.76,0,0,0,1.873-.461,2.839,2.839,0,0,0,1.206-1.261,4.4,4.4,0,0,0,.294-1.823Z",
    transform: "translate(-298.769 -276.057)",
    fill: "#d42733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49387",
    "data-name": "Path 49387",
    d: "M427.158,304.173V289.324h1.823v14.849Z",
    transform: "translate(-320.313 -269.211)",
    fill: "#d42733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49388",
    "data-name": "Path 49388",
    d: "M438.157,315.594l-.2-1.712a4.083,4.083,0,0,0,1.044.162,2,2,0,0,0,.972-.2,1.657,1.657,0,0,0,.6-.568,8.931,8.931,0,0,0,.557-1.357c.033-.1.088-.25.162-.446l-4.082-10.777h1.965l2.238,6.229q.435,1.185.78,2.492a24.446,24.446,0,0,1,.75-2.451l2.3-6.27h1.824l-4.092,10.939a21.487,21.487,0,0,1-1.023,2.441,3.6,3.6,0,0,1-1.114,1.321,2.632,2.632,0,0,1-1.5.42A3.658,3.658,0,0,1,438.157,315.594Z",
    transform: "translate(-326.745 -276.488)",
    fill: "#d42733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49389",
    "data-name": "Path 49389",
    d: "M466.869,307.808l1.8-.284a2.516,2.516,0,0,0,.846,1.661,2.946,2.946,0,0,0,1.939.578,2.848,2.848,0,0,0,1.864-.512,1.529,1.529,0,0,0,.608-1.2,1.107,1.107,0,0,0-.537-.972,7.914,7.914,0,0,0-1.864-.618,16.984,16.984,0,0,1-2.78-.876,2.654,2.654,0,0,1-1.575-2.466,2.773,2.773,0,0,1,.329-1.332,2.948,2.948,0,0,1,.9-1.018,3.775,3.775,0,0,1,1.16-.532,5.523,5.523,0,0,1,1.575-.218,6.232,6.232,0,0,1,2.223.365,3.028,3.028,0,0,1,1.413.988,3.861,3.861,0,0,1,.628,1.666l-1.783.243a1.949,1.949,0,0,0-.7-1.3,2.576,2.576,0,0,0-1.646-.466,2.978,2.978,0,0,0-1.793.415,1.208,1.208,0,0,0-.537.972,1.006,1.006,0,0,0,.222.638,1.605,1.605,0,0,0,.7.486q.273.1,1.611.466a22.44,22.44,0,0,1,2.7.846,2.74,2.74,0,0,1,1.2.957,2.673,2.673,0,0,1,.435,1.56,3.061,3.061,0,0,1-.532,1.717,3.439,3.439,0,0,1-1.534,1.246,5.587,5.587,0,0,1-2.269.44,5.054,5.054,0,0,1-3.2-.871A4.049,4.049,0,0,1,466.869,307.808Z",
    transform: "translate(-345.733 -276.057)",
    fill: "#d42733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49390",
    "data-name": "Path 49390",
    d: "M499.911,303.137l.263,1.611a6.806,6.806,0,0,1-1.378.162,3.116,3.116,0,0,1-1.539-.314,1.756,1.756,0,0,1-.77-.826,6.515,6.515,0,0,1-.223-2.152v-6.189h-1.337v-1.418h1.337v-2.663l1.813-1.094v3.758h1.834v1.418h-1.834v6.29a3.178,3.178,0,0,0,.1,1,.755.755,0,0,0,.314.354,1.206,1.206,0,0,0,.623.132A5.951,5.951,0,0,0,499.911,303.137Z",
    transform: "translate(-363.695 -269.804)",
    fill: "#d42733"
  })), /*#__PURE__*/React.createElement("text", {
    id: "P_RTAL",
    "data-name": "P   RTAL",
    transform: "translate(140.172 24.828)",
    fill: "#4698cb",
    fontSize: 20,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21,
    xmlSpace: "preserve"
  }, "P   RTAL"))), /*#__PURE__*/React.createElement("g", {
    id: "Component_159_45",
    "data-name": "Component 159 \\u2013 45",
    transform: "translate(145 28.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24330",
    "data-name": "Group 24330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24329",
    "data-name": "Group 24329",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14164",
    "data-name": "Rectangle 14164",
    width: 14.465,
    height: 14.441,
    fill: "#4698cb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24332",
    "data-name": "Group 24332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24331",
    "data-name": "Group 24331",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49270",
    "data-name": "Path 49270",
    d: "M306.765,62.584c-.005-.017-.011-.033-.016-.05s-.01-.033-.015-.05l0-.011a7.258,7.258,0,0,0-2.831-3.793h0l-.029-.021h0a.705.705,0,0,0-.635-.021,9.423,9.423,0,0,0-2.243,1.237c-.887.641-1.88,1.435-2.177,1.7a.826.826,0,0,0-.132,1.286c.511.495,4.37,4.271,4.585,4.469a.759.759,0,0,0,1.086.041,12.587,12.587,0,0,0,1.619-2.086,7.849,7.849,0,0,0,.742-1.633,1.718,1.718,0,0,0,.055-1.067Z",
    transform: "translate(-292.586 -57.428)",
    fill: "#c50c23"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgLogoTextPortal);
export default __webpack_public_path__ + "static/media/cg-logo-text-portal.1a9d27720492f8c59847f0ef49c9a4a7.svg";
export { ForwardRef as ReactComponent };